import React from 'react';

import { useHistory } from 'react-router-dom';

import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import { Pills } from 'components/common/pills/pills';

import { CustomizedRoundIcon } from 'components/common';
import { useSegmentCellLogic } from 'components/widgets/RiskRegister/components/SegmentCell/SegmentCell.logic';
import classes from 'components/widgets/RiskRegister/components/SegmentCell/SegmentCell.module.scss';
import { useSegmentCellProvider } from 'components/widgets/RiskRegister/components/SegmentCell/SegmentCell.provider';
import { Props } from 'components/widgets/RiskRegister/components/SegmentCell/SegmentCell.types';

export const SegmentCell = ({ activitiesByKey, linkOption }: Props) => {
    const { api } = useSegmentCellProvider({ activitiesByKey });
    const { selectedLinkOption, title, value } = useSegmentCellLogic({ activitiesByKey, linkOption, api });
    const history = useHistory();

    const handleSelectSegment = (url: string) => {
        history.push(`/${url}`);
    };

    switch (selectedLinkOption) {
        case 'all':
            return (
                <div className={classes.segmentCell}>
                    <div className={classes.title}>{title}</div>
                </div>
            );
        case 'cluster':
        case 'wbs':
            return (
                <div className={classes.segmentCell}>
                    <div className={classes.title}>{title}:</div>{' '}
                    <div className={classes.value}>
                        <Pills>{value}</Pills>
                    </div>
                </div>
            );
        case 'activityCodes':
        case 'specific':
            return (
                <div className={classes.segmentCell}>
                    <div className={classes.title}>{title}:</div> <Pills>{value?.[0] ?? 'N/A'}</Pills>{' '}
                    <div className={classes.more}>
                        {Array.isArray(value) && value?.length > 1 ? `& ${value?.length - 1} more...` : ''}
                    </div>
                </div>
            );
        case 'segment':
            return (
                <div className={classes.segmentCell}>
                    <div className={classes.title}>{title}:</div> <Pills>{value?.name ?? 'N/A'}</Pills>{' '}
                    {value && (
                        <div className={classes.linkToSegment}>
                            <CustomizedRoundIcon onClick={() => value.url && handleSelectSegment(value.url)}>
                                <MuiIcon icon={'open_in_new'} fontSize={'2.5rem'} />
                            </CustomizedRoundIcon>
                        </div>
                    )}
                </div>
            );
        default:
            return null;
    }
};
